// extracted by mini-css-extract-plugin
module.exports = {"button":"TeacherButton_button__R1jGL","solid":"TeacherButton_solid__qza5B","outline":"TeacherButton_outline__1kfb0","strongOutline":"TeacherButton_strongOutline__u7aP2"};